 window.addEventListener("mouseover", (e) => {
     if (e.target.closest(".bm-product-card__variants") && e.target.nodeName === "A") {
       // Elements
       const $closestProduct = e.target.closest(".bm-product-card");
       const $closestProductMedia = $closestProduct.querySelector(".bm-product-card__media__image");
       // Attributes
       const color = e.target.getAttribute("data-color");
       const image = e.target.getAttribute("data-image");
       $closestProductMedia.style.cssText = `
        background-color: ${color};
        background-image: url(${image}); 
      `;
    }
});